import { createSvgIcon } from "@mui/material";

export const OpenInNewIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 283.46 283.46" fill="currentColor">
        <g>
            <path d="M222.14,211.54L71.93,61.32L61.32,71.93l12.62,12.62v105.98c0,10.75,8.75,19.5,19.5,19.5h105.98l12.12,12.12L222.14,211.54
                z M93.44,195.03c-2.44,0-4.5-2.06-4.5-4.5V99.55l42.18,42.18l-12.68,12.68l10.61,10.61l12.68-12.68l42.69,42.69H93.44z"/>
            <polygon points="164.77,128.29 197.98,95.08 220.82,117.92 220.82,61.63 164.53,61.63 187.37,84.47 154.16,117.68"/>
            <polygon points="147.31,62.29 97.66,62.29 112.65,77.29 147.31,77.29"/>
            <polygon points="206.17,169.52 221.17,184.64 221.17,134.99 206.17,134.99"/>
        </g>
    </svg>,
    'OpenInNewIcon'
)
